<div class="staking" id="staking">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="banner-content">
          <div class="left">
            <h3 class="fw-bold font-28 font-sm-48 m-0">{{ 'staking.title' | translate }}</h3>

            <!--- connect wallet button -->
            <div class="d-flex wallet_audit_wrap mt-3 align-items-center justify-content-between">
              <div class="rounded-3 btn btn-primary mxw-200 fw-bold" (click)="showWidget('home')" *ngIf="!walletAddress">{{ 'misc.connect_wallet' | translate }}</div>
              <div class="rounded-3 btn btn-primary mxw-200 fw-bold" (click)="disconnect()" *ngIf="walletAddress">{{ walletAddress | trimAddress }}</div>
              <div (click)="redirectToExternalURL('https://coinsult.net/projects/pepe-unchained-2/')" class="audit-wrapper cursor-pointer">
                <p class="text">{{"misc.trust_audit" | translate}}</p>
                <img class="icon" src="/assets/images/svg-icons/audit_1.svg" alt="">
              </div>
            </div>

            <!--- trusted by--->
            <div class="trusted-by mt-4">
              <span>{{ 'staking.truted_by' | translate }}</span>

              <div class="logos-wrap">
                <img src="/assets/images/svg-icons/metamask-staking.svg" alt="MetaMask" />
                <img src="/assets/images/svg-icons/bestwallet.svg" alt="Best Wallet" />
                <img src="/assets/images/svg-icons/coinbase-staking.svg" alt="Coinbase" />
                <img src="/assets/images/svg-icons/trust.svg" alt="Trust Wallet" />
              </div>
            </div>
          </div>

          <div class="right">
            <div class="glowBtn  d-inline-block text-black rounded-4">
              <span class="text-center d-flex justify-content-center">Current Staking Rewards</span>
              <h2 class="m-0 fw-bold font-30 font-sm-38 text-center">{{ stakeData.rewardPerRound }}%</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-12 mt-4">
        <div class="box-wrap">
          <!-- ====== Buy and stake card ====== -->

          <div class="box">
            <div>
              <span class="title">{{ 'staking.card_1_title' | translate }}</span>
              <h2 class="value">
                {{ userStaked }}
                <span class="coin">{{ 'staking.card_coin' | translate }}</span>
              </h2>
            </div>
            <div>
              <span class="title">{{ 'staking.your_stakeable' | translate }} </span>
              <h2 class="value">
                {{ formatNumber(ethClaimable) }}
                <span class="coin">{{ 'staking.card_coin' | translate }}</span>
              </h2>
            </div>

            <!-- == Claim And Stake == -->
            <a class="btn btn-primary  w-100 mt-3 rounded-1 fw-semibold text-uppercase" title="staking" *ngIf="ethTokens && ethTokens > 0" (click)="claimAndStake()">{{ 'staking.claim_stake' | translate }}</a>

            <!-- == Buy And Stake == -->
            <!-- <a class="btn btn-primary bg-white w-100 mt-3 text-uppercase fw-semibold" (click)="buyClaimStake(buy_stake)" *ngIf="ethTokens == 0">     {{ 'widget.stake_now' | translate }}</a> -->

            <!-- == Stake Now  == -->
            <!-- It can be used to stake the tokens after token live -->
            <a class="btn btn-primary  w-100 mt-3 text-uppercase fw-semibold" title="staking" *ngIf="!ethTokens || ethTokens === 0" (click)="openModal(stake)" translate>{{"widget.stake_now" | translate}}</a>
          </div>

          <!-- ====== % OF POOL card ====== -->
          <div class="box">
            <div class="w-100">
              <div class="d-flex align-items-center justify-content-between">
                <span class="title">{{ 'staking.card_2_title' | translate }}</span>
                <img src="/assets/images/svg-icons/info-icon.svg" class="img-fluid cursor-pointer" alt="" (click)="poolInfo()" />
              </div>
              <h2 class="value">{{ poolPercent }}%</h2>
              <div>
                <span class="title">{{ 'staking.total_staked' | translate }}</span>
                <h2 class="value">
                  {{ totalStaked }}
                  <span class="coin">{{ 'staking.card_coin' | translate }}</span>
                </h2>
              </div>
              <button class="btn btn-outline-primary w-100 mt-4 text-uppercase" (click)="openModal(withdraw)">{{ 'staking.withdraw_title' | translate }}</button>
            </div>
          </div>

          <!-- ====== Estimated reward  card====== -->

          <div class="box">
            <div>
              <span class="title">{{ 'staking.card_3_title' | translate }}</span>
              <h2 class="value">
                {{ stakeData.apy }}%<sup class="coin ps-2 mt-2">{{ 'staking.stake_pa' | translate }}</sup>
              </h2>
            </div>
            <ul class="p-0 mt-3 mb-0">
              <li><img src="/assets/images/svg-icons/arrow-right.svg" height="8px" class="me-1" alt="" />{{ 'staking.card_3_para_1' | translate }}</li>
              <li><img src="/assets/images/svg-icons/arrow-right.svg" height="8px" class="me-1" alt="" />{{ 'staking.card_3_para_2' | translate }}</li>
              <li><img src="/assets/images/svg-icons/arrow-right.svg" height="8px" class="me-1" alt="" />{{ 'staking.card_3_para_3' | translate }}</li>
            </ul>
          </div>

          <!-- ====== Current Reward card====== -->

          <!-- <div class="box">
            <div>
              <span class="title">{{ 'staking.card_4_title' | translate }}</span>
              <h2 class="value">
                {{ stakeData.rewardPerRound }}
                <sup class="coin">{{ 'staking.card_block' | translate }}</sup>
              </h2>
            </div>
          </div> -->

          <!-- ====== Total Reward card====== -->

          <div class="box">
            <div>
              <span class="title">{{ 'staking.card_5_title' | translate }}</span>
              <h2 class="value">
                {{ userReward }}
                <span class="coin">{{ 'staking.card_coin' | translate }}</span>
              </h2>
            </div>
            <button class="btn btn-primary  w-100 mt-3 text-uppercase fw-semibold" (click)="harvestRewards()">{{ 'staking.rewards_btn' | translate }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ====== chart wrapper ====== -->

    <div class="row mt-4 align-items-center justify-content-between">
      <div class="col-lg-12 mb-3">
        <div class="chart-wrapper">
          <div class="px-3">
            <h4 class="text-start pt-4">{{ 'staking.total_rewards' | translate }}</h4>
          </div>
          <div class="w-100 graph-parent" #graphCont *ngIf="pageLoaded">
            <ngx-charts-bar-vertical
              [view]="view"
              [scheme]="colorScheme"
              [results]="rewards"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legendTitle]="legendTitle"
              [legend]="showLegend"
              [yScaleMin]="minYAxis"
              [yScaleMax]="maxYAxis"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [showGridLines]="showGridLines"
              [showDataLabel]="showDataLabel"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              [yAxisTickFormatting]="yAxisTickFormattingFn"
            >
            </ngx-charts-bar-vertical>
          </div>
        </div>

        <div class="mt-2">
          <p class="font-14 text-grey text-center mb-0">
            {{ 'staking.staking_powered_by' | translate }}
            <a href="https://web3paymentsolutions.io/" target="_blank">
              <img src="/assets/images/svg-icons/W3P_White.svg" alt="Web3Payments" class="poweredByIcon" height="18" />
            </a>
          </p>
        </div>
      </div>
    </div>

    <!---footer bottom -->

    <div class="row text-center footer mt-4">
      <span>
        {{ 'footer.copyright' | translate }}
      </span>
      <span class="fw-bold">
        {{ 'footer.disclaimer' | translate }}
      </span>
      <span>
        {{ 'footer.disclaimer_desc' | translate }}
      </span>
      <span class="fw-bold">
        {{ 'footer.terms' | translate }}
      </span>
    </div>
  </div>
</div>

<!-- ====== token withdraw modal ====== -->

<ng-template #withdraw>
  <div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <h4 class="modal-title pull-left">{{ 'staking.withdraw_title' | translate }}</h4>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <span>{{ 'staking.card_1_title' | translate }}</span>
      <h2 class="font-25">
        {{ userStaked }}
        <span class="font-14">{{ 'staking.card_coin' | translate }}</span>
      </h2>
      <div class="d-inline-block text-white ms-2 font-14" *ngIf="stakeData.userStaked > 0">
        {{ 'staking.withdraw_text' | translate: { unstakeDate: (unstakeDate | date: 'dd/MM/yyyy hh:mm:aa') } }}
      </div>
    </div>

    <div class="d-flex align-items-center gap-2 mt-3">
      <button class="btn btn-outline-primary w-100" (click)="closeModal()">{{ 'misc.cancel' | translate }}</button>
      <button class="btn btn-primary w-100" (click)="withdrawStake()" [disabled]="!canUnstake">{{ 'staking.withdraw' | translate }}</button>
    </div>
  </div>
</ng-template>

<!-- ====== stake modal ====== -->

<ng-template #stake>
  <div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <h4 class="modal-title">{{ 'widget.stake_token' | translate }}</h4>
  </div>
  <div class="modal-body">
    <div class="text-center mb-3">
      <span class="staking-title font-14 text-uppercase mb-1 d-inline-block">{{ 'widget.user_bal' | translate }}</span>
      <h2 class="font-25 mt-2 text-secondary d-flex align-items-start fw-bold justify-content-center">
        {{ userBal }}
        <span class="d-inline-block text-white ms-2 font-12 fw-bold">{{ 'staking.card_coin' | translate }}</span>
      </h2>
    </div>

    <div class="form-group">
      <div class="d-flex align-items-center justify-content-between">
        <label class="font-12">{{ 'widget.stake_amount' | translate }}</label>
        <a class="font-12 text-decoration-underline cursor-pointer text-secondary" (click)="max()">{{ 'widget.max' | translate }}</a>
      </div>
      <input type="text" class="form-control text-black" placeholder="0" [(ngModel)]="stakeAmount" />
      <p class="font-13">{{ 'widget.enterAmount' | translate }}</p>
    </div>

    <div class="d-flex align-items-center">
      <button class="btn btn-outline-primary font-16  ms-3 w-100" (click)="closeModal()">{{ 'misc.cancel' | translate }}</button>
      <button class="btn btn-primary font-16  ms-3 w-100" [disabled]="!stakeAmount || stakeData.userBal === 0" (click)="stakeToken(successfull);">{{"widget.stake_now" | translate}}</button>
    </div>
  </div>
</ng-template>

<!-- ====== successful modal ====== -->
<ng-template #successfull>
  <div class="modal-body d-flex align-items-center flex-column justify-content-center">
    <div class="text-center w-100 mb-3">
      <!-- ====== show loader ====== -->
      <div class="body-section text-center" *ngIf="status === SwapStatus.in_progess">
        <img src="/assets/images/svg-icons/logo.svg" alt="loading" class="statusIcon loading" />
        <div class="fw-normal fw-bold font-16 px-2 my-3 text-uppercase text-white text-center">{{ 'widget.transaction_in_progress' | translate }}</div>
        <p class="fs-7 mb-0 text-white">{{ 'staking.stake_transction_info' | translate: { stakeAmount } }}</p>
      </div>

      <!-- ====== show confirm ====== -->

      <div class="body-section text-center" *ngIf="status === SwapStatus.confirm_pending">
        <img src="/assets/images/svg-icons/logo.svg" alt="loading" class="statusIcon loading" />
        <div class="fw-semibold fs-6 my-3 text-uppercase text-black text-center">{{ 'misc.confirm' | translate }}</div>
        <p class="fs-7 mb-0 text-white">{{ 'staking.stake_waiting_confirm' | translate: { cryptoName } }}</p>
      </div>

      <!-- ====== show pending ====== -->

      <div class="body-section text-center" *ngIf="status === SwapStatus.approval_pending">
        <img src="/assets/images/svg-icons/logo.svg" alt="loading" class="statusIcon loading" />
        <div class="fw-semibold fs-6 my-3 text-uppercase text-black text-center">{{ 'widget.authorise' | translate }}</div>
        <p class="fs-7 mb-0 text-white">{{ 'staking.stake_waiting_approve' | translate }}</p>
      </div>

      <!-- ====== show success/completed ====== -->

      <div class="body-section text-center" *ngIf="status === SwapStatus.complete">
        <img src="/assets/images/popup-icons/success.svg" alt="complete" class="statusIcon" />
        <div class="fw-semibold fs-6 my-3 text-uppercase text-success text-center">{{ 'stake_transaction_success' | translate }}</div>
        <p class="fs-7 mb-3 mb-lg-4 text-black">{{ 'staking.stake_transction_info' | translate: { stakeAmount } }}</p>

        <div class="d-flex align-items-center justify-content-center gap-3">
          <button class="btn btn-outline-primary fs-7 w-80" (click)="viewUrl()">{{ 'widget.view_transaction' | translate }}</button>
          <button class="btn btn-primary fs-7 w-100" (click)="closeModal()">{{ 'misc.done' | translate }}</button>
        </div>
      </div>

      <!-- ====== show failed ====== -->

      <div class="body-section text-center" *ngIf="status === SwapStatus.failed">
        <img src="/assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon" />
        <div class="fw-semibold fs-6 my-3 text-uppercase text-danger text-center">{{ 'staking.stake_transaction_failed' | translate }}</div>
        <p class="fs-7 mb-3 mb-lg-4 text-warning">{{ 'staking.stake_view_transaction_info' | translate }}</p>

        <div class="d-flex align-items-center justify-content-center gap-3">
          <button class="btn btn-outline-primary fs-7 w-80" (click)="viewUrl()">{{ 'widget.view_transaction' | translate }}</button>
          <button class="btn btn-primary fs-7 w-100" (click)="closeModal()">{{ 'misc.done' | translate }}</button>
        </div>
      </div>

      <!-- ====== show rejected ====== -->

      <div class="body-section text-center" *ngIf="status === SwapStatus.rejected">
        <img src="/assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon" />
        <div class="fw-semibold fs-6 text-uppercase text-warning my-3 text-center">{{ 'staking.stake_transaction_rejected' | translate }}</div>

        <div class="d-flex align-items-center justify-content-center gap-3 mt-4">
          <button class="btn btn-primary fs-7 w-100" (click)="closeModal()">{{ 'misc.done' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- ====== Buy and stake modal ====== -->
<ng-template #buy_stake>
  <div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <h4 class="modal-title">{{ 'staking.buy_stake' | translate }}</h4>
    <svg-icon src="/assets/images/svg-icons/close-white.svg" [svgStyle]="{ 'width.px': 12, 'height.px': 12 }" class="cursor-pointer stake-close" (click)="closeModal()"></svg-icon>
  </div>
  <div class="modal-body">
    <!-- <app-swap [isNative]="true" [isWert]="isWert" [isModal]="true" (messageEvent)="messageEvent($event)"></app-swap> -->
    <app-swap-v2 [isNative]="true" [isWert]="isWert" [isModal]="true" (messageEvent)="messageEvent($event)"></app-swap-v2>
  </div>
</ng-template>
